import { Model } from 'modules/core/lib/mobx-rest'

export interface ITemplateVariable {
  name: string
  legal_entities: string[]
  section: string
  variable: string
  is_custom_field: boolean
  access: string
  permission_label: string
}

class Variable extends Model<ITemplateVariable> {}

export default Variable
